import React from "react";

const ASP_Response = () => {
  return (
    <div className="tutorial-page">
      <h1>ASP Response</h1>
      <p>This is the ASP Response page content.</p>
    </div>
  );
};

export default ASP_Response;
